
import SmartStoresStock     from '@/components/frontOffice/SmartStoresStock.vue'
import StoreStockMatching   from '@/components/frontOffice/StoreStockMatching.vue'
import StoreDocuments       from '@/components/frontOffice/StoreDocuments.vue'
import StoreProductColorMatching   from '@/components/frontOffice/StoreProductColorMatching.vue'
import SupplierCatalog      from '@/components/frontOffice/SupplierCatalog.vue'
import ProductStoreRestock  from '@/components/frontOffice/ProductStoreRestocking.vue'

const menuId = 'fo3'
const routes = [
    {
        path        : '/smart2', 
        name        : 'smartStock',
        component   : SmartStoresStock,
        meta        : { name : 'Stock Smart', visible : true ,icon : 'fas fa-camera',menu:menuId,color:'#3399CC'},   
    },
    {
        path        : '/matching', 
        name        : 'stockMatching',
        component   : StoreStockMatching,
        meta        : { name : 'Stock Matching', visible : true ,icon : 'fas fa-clipboard-check',menu:menuId,color:'#000066'},   
    },
    {
        path        : '/product-matching', 
        name        : 'productMatching',
        component   : StoreProductColorMatching,
        meta        : { name : 'Esposizione Colore Matching', visible : true ,icon : 'fas fa-palette',menu:menuId,color:'#0066FF'},   
    },
    {
        path        : '/store-documents', 
        name        : 'stockDelivered',
        component   : StoreDocuments,
        meta        : { name : 'Stock consegnato', visible : true ,icon : 'fas fa-shipping-fast',menu:menuId,color:'#0066FF'},   
    },
    {
        path        : '/catalog', 
        name        : 'supplierCatalog',
        component   : SupplierCatalog,
        meta        : { name : 'Catalogo fornitore', visible : true ,icon : 'fas fa-camera',menu:menuId,color:'green'},   
    },
    {
        path        : '/restocking', 
        name        : 'restocking',
        component   : ProductStoreRestock,
        meta        : { name : 'Restocking Sede', visible : true ,icon : 'fas fa-project-diagram',menu:menuId,color:'#8000ff'},   
    },
    
    
]
export default routes
